import { useCallback } from "react";
import {
  getCCAFieldDefinitions,
  getCCARequiredFlags,
  getExistingCodes,
} from "../../../api/AnalysisCodes";
import { useWorkOrderStore } from "../../../store/wo-order";

type Props = {
  woEventDateCreated: string;
  woEventTimeCreated: string;
  woEquipment: string;
  woNumber: string;
};

export default function useGetIsCAARequiredForCompletion() {
  const setCaaIsRequiredForWoCompletion = useWorkOrderStore(
    (state) => state.setCaaIsRequiredForWoCompletion
  );

  const getIsCAARequiredForCompletion = useCallback(
    async (data: Props) => {
      const { woEquipment, woEventDateCreated, woEventTimeCreated, woNumber } =
        data;
      const fields = await getCCAFieldDefinitions(woEquipment);
      let existingCodes: any[] = [];
      if (woEventDateCreated && woEventTimeCreated) {
        existingCodes =
          (await getExistingCodes(woEventDateCreated, woEventTimeCreated)) ||
          [];
      }
      /* US 906024 - a plant can express "analysis codes are mandatory for this equipment class"
         as a Required flag on the EquipmentClass -> Component field mapping instead of on the
         element itself. Reading only the element settings let those work orders complete with no
         codes at all. Only the EquipmentClass rule can be judged here - nothing further down the
         chain has been picked yet, which is exactly the question being asked. */
      const workOrder = useWorkOrderStore.getState().getWorkOrderById(woNumber);
      const { componentRequired } = await getCCARequiredFlags({
        equipmentClass: workOrder?.EquipmentClass,
      });
      const isCaaRequired = !!(
        fields &&
        (fields.componentField?.IsRequired ||
          fields.actionField?.IsRequired ||
          fields.conditionField?.IsRequired ||
          componentRequired) &&
        existingCodes.length === 0
      );

      setCaaIsRequiredForWoCompletion(woNumber, isCaaRequired);

      return isCaaRequired;
    },
    [setCaaIsRequiredForWoCompletion]
  );

  return { getIsCAARequiredForCompletion };
}
